import { render, staticRenderFns } from "./calcu.vue?vue&type=template&id=1030c674&scoped=true"
import script from "./calcu.vue?vue&type=script&lang=js"
export * from "./calcu.vue?vue&type=script&lang=js"
import style0 from "./calcu.vue?vue&type=style&index=0&id=1030c674&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030c674",
  null
  
)

export default component.exports